import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableDashboard = Loadable({
  loader: function loader() {
    return import('../AdminDashboard/AdminDashboard.jsx');
  },
  loading: ComponentLoading
});
export default LoadableDashboard;